import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = ({ backgroundImage }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <img
          src={getImageFromS3('images/sms-mrl-prpl/head.gif')}
          alt="head-gif"
          className={styles.headGif}
        />
        <img
          src={getImageFromS3('images/sms-mrl-prpl/head.png')}
          alt="head"
          className={styles.headImage}
        />
        <div className={styles.mainContent}>
          <div className={styles.formatTitle}>У супертонкому форматі</div>
          <div className={styles.tobaccoContainer}>
            <img
              src={getImageFromS3('images/sms-mrl-prpl/tobacco.png')}
              alt="tobacco"
            />
            <div className={styles.textContainer}>
              <p>Оновлена тютюнова суміш</p>
              <p>Вміст смол - 4 мг</p>
            </div>
          </div>
          <div className={styles.filterContainer}>
            <p>
              Ущільнений<br></br> ацетатний<br></br> фільтр
            </p>
            <p>
              Краще тримає<br></br> форму
            </p>
            <img
              src={getImageFromS3('images/sms-mrl-prpl/filter.png')}
              alt="filter"
            />
          </div>
          <div className={styles.qrInsidePackContainer}>
            <p>
              QR-код<br></br> в середині<br></br> пачки
            </p>
            <p>
              Залишити відгук <br></br> Лайв-чат<br></br> Релакс контент
            </p>
            <img
              src={getImageFromS3('images/sms-mrl-prpl/qrInsidePack.png')}
              alt="qrInsidePack"
            />
          </div>
          <div className={styles.blocksContainer}>
            <p className={styles.title}>
              ТАКОЖ ДОСТУПНИЙ <br></br>У БЛОКАХ
            </p>
            <p className={styles.description}>у фірмовому дизайні</p>
            <img
              src={getImageFromS3('images/sms-mrl-prpl/blocks.png')}
              alt="blocks"
            />
            <img
              src={getImageFromS3('images/sms-mrl-prpl/blocks.gif')}
              alt="blocks-gif"
              className={styles.gif}
            />
          </div>
          <div className={styles.newsContainer}>
            <p className={styles.title}>
              Хочеш отримувати новини про цю продукцію?
            </p>
            <p className={styles.description}>
              Проходь невелике опитування<br></br> та <b>отримуй 30 грн</b> на
              мобільний<br></br> за витрачений час
            </p>
            <button
              onClick={() => {
                window.location.href =
                  'https://www.scanpack.com/ua-reg?utm_campaign=25UA-KV5&returned=true';
              }}
            >
              Пройти опитування
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
